import { render, staticRenderFns } from "./Configurator.vue?vue&type=template&id=08d4b3bc&"
import script from "./Configurator.vue?vue&type=script&lang=ts&"
export * from "./Configurator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports